module.exports = __webpack_public_path__ + "img/creators1.1d602f9d.jpg";